import { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Consent() {
  const { user, refresh } = useAuth();
  const [storage, setStorage] = useState(!!user?.consents?.storage?.granted);
  const [improvement, setImprovement] = useState(!!user?.consents?.improvement?.granted);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const next = useLocation().state?.next || "/analisi/nuova";

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/me/consent", { storage, improvement });
      await refresh();
      if (storage) navigate(next, { replace: true });
      else toast.info("Senza il consenso alla conservazione non è possibile avviare un'analisi.");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-6 py-10" data-testid="consent-page">
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#C9A96E] text-[#0D2517]"><ShieldCheck /></span>
      <p className="eyebrow mt-5">Privacy</p>
      <h1 className="font-serif text-3xl font-semibold text-[#0D2517]">Le tue foto restano private</h1>
      <p className="mt-3 text-sm leading-relaxed text-[#2D3A30]">
        Fotografie e informazioni sulla pianta vengono conservate in modo riservato, visibili solo a te. Saranno condivise con la
        Dott.ssa De Vanna <strong>solo se richiedi una consulenza</strong> e lo autorizzi esplicitamente.
      </p>

      <div className="mt-8 space-y-4">
        <label className="flex gap-3 rounded-xl border border-[#E2DCD0] bg-white p-4" data-testid="consent-storage-label">
          <Checkbox checked={storage} onCheckedChange={(v) => setStorage(!!v)} data-testid="consent-storage-checkbox" className="mt-0.5" />
          <span className="text-sm"><strong>Obbligatorio.</strong> Acconsento alla conservazione delle mie fotografie e dell'anamnesi per ricevere l'analisi e mantenere lo storico delle mie piante.</span>
        </label>
        <label className="flex gap-3 rounded-xl border border-[#E2DCD0] bg-white p-4" data-testid="consent-improvement-label">
          <Checkbox checked={improvement} onCheckedChange={(v) => setImprovement(!!v)} data-testid="consent-improvement-checkbox" className="mt-0.5" />
          <span className="text-sm"><strong>Facoltativo.</strong> Acconsento all'uso anonimo dei miei casi per migliorare la base di conoscenza agronomica. Revocabile in qualsiasi momento.</span>
        </label>
      </div>
      <p className="mt-4 text-xs text-[#8a958d]">Puoi esportare o cancellare i tuoi dati dal Profilo. Nessun altro uso senza consenso. <Link to="/privacy" className="underline" data-testid="consent-privacy-link">Leggi l'informativa privacy</Link>, inclusi i servizi esterni (analisi AI e identificazione botanica Pl@ntNet).</p>
      <button onClick={save} disabled={busy} className="btn-primary mt-8 w-full" data-testid="consent-save-button">
        {busy ? "Salvataggio…" : "CONFERMA E CONTINUA"}
      </button>
    </div>
  );
}
